export interface Creator {
  id: string;
  name: string;
  username: string;
  avatar: string;
  isVerified: boolean;
  category?: string;
  followerCount?: string;
  bio?: string;
  isFollowing?: boolean;
}

export interface PostMedia {
  type: "image" | "video";
  url: string;
  posterUrl?: string; // Thumbnail for videos
  aspectRatio?: "16/9" | "4/3" | "1/1" | "4/5" | "3/2";
  isLocked?: boolean;
  unlockPrice?: number;
  duration?: string;
}

export interface PostComment {
  id: string;
  authorName: string;
  authorAvatar: string;
  text: string;
  timeAgo: string;
  likesCount: number;
}

export interface FeedPost {
  itemType: "post";
  id: string;
  creator: Creator;
  timeAgo: string;
  createdAt?: string;
  caption: string;
  hashtags: string[];
  tags?: string[];
  category?: string;
  media: PostMedia[];
  likesCount: string | number;
  commentsCount: string | number;
  sharesCount: string | number;
  isLiked?: boolean;
  isBookmarked?: boolean;
  comments?: PostComment[];
}

export interface CreatorSpotlightItem {
  itemType: "spotlight";
  id: string;
  title: string; // e.g. "Top on member's creators"
  creator: Creator;
  galleryPreviews: {
    id: string;
    url: string;
    isLocked?: boolean;
    lockTitle?: string;
    lockSubtitle?: string;
  }[];
  profileLink: string;
}

export type FeedItem = FeedPost | CreatorSpotlightItem;
export type Post = FeedPost;

export interface VaultDropItem {
  id: string;
  title: string;
  creator: string;
  price: string;
  coverImage: string;
}

export interface StoryItem {
  id: string;
  creator: Creator;
  hasUnseenStory: boolean;
  isLive?: boolean;
}

// --------------------------------------------------------
// Figma Timeline Dummy Feed
// --------------------------------------------------------
export const DUMMY_TIMELINE_DATA: FeedItem[] = [
  // 1. Jenny Wilson Portrait Post
  {
    itemType: "post",
    id: "post-1",
    creator: {
      id: "jenny-wilson",
      name: "Jenny Wilson",
      username: "jenny",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80",
      isVerified: true,
      category: "Glamour & Lifestyle",
      isFollowing: true,
    },
    timeAgo: "2h ago",
    createdAt: "2h ago",
    caption: "Ready for new videos? Follow me for weekly drops.",
    hashtags: ["#fun", "#lifestyle"],
    tags: ["#fun", "#lifestyle"],
    category: "Glamour & Lifestyle",
    media: [
      {
        type: "image",
        url: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=1200&auto=format&fit=crop&q=80",
        aspectRatio: "4/3",
      },
    ],
    likesCount: "987.2K",
    commentsCount: "47.2K",
    sharesCount: "4.53K",
    isLiked: false,
    isBookmarked: false,
  },

  // 2. Jenny Wilson Poolside Bikini Post
  {
    itemType: "post",
    id: "post-2",
    creator: {
      id: "jenny-wilson",
      name: "Jenny Wilson",
      username: "jenny",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80",
      isVerified: true,
      category: "Glamour & Lifestyle",
      isFollowing: true,
    },
    timeAgo: "2h ago",
    createdAt: "2h ago",
    caption: "Ready for new videos? Follow me for weekly drops.",
    hashtags: ["#fun", "#lifestyle"],
    tags: ["#fun", "#lifestyle"],
    category: "Glamour & Lifestyle",
    media: [
      {
        type: "image",
        url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&auto=format&fit=crop&q=80",
        aspectRatio: "16/9",
      },
    ],
    likesCount: "987.2K",
    commentsCount: "47.2K",
    sharesCount: "4.53K",
    isLiked: false,
    isBookmarked: false,
  },

  // 3. Jenny Wilson Rocky Beach Swimsuit Post
  {
    itemType: "post",
    id: "post-3",
    creator: {
      id: "jenny-wilson",
      name: "Jenny Wilson",
      username: "jenny",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80",
      isVerified: true,
      category: "Glamour & Lifestyle",
      isFollowing: true,
    },
    timeAgo: "2h ago",
    createdAt: "2h ago",
    caption: "Ready for new videos? Follow me for weekly drops.",
    hashtags: ["#fun", "#lifestyle"],
    tags: ["#fun", "#lifestyle"],
    category: "Glamour & Lifestyle",
    media: [
      {
        type: "image",
        url: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=1200&auto=format&fit=crop&q=80",
        aspectRatio: "16/9",
      },
    ],
    likesCount: "987.2K",
    commentsCount: "47.2K",
    sharesCount: "11.72K",
    isLiked: false,
    isBookmarked: false,
  },

  // 4. Spotlight Card: "Top on member's creators"
  {
    itemType: "spotlight",
    id: "spotlight-1",
    title: "Top on member's creators",
    creator: {
      id: "tiana-mya",
      name: "Tiana Mya",
      username: "tianamya",
      avatar: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=300&auto=format&fit=crop&q=80",
      isVerified: true,
      category: "VIP Exclusive Model",
      isFollowing: false,
    },
    galleryPreviews: [
      {
        id: "prev-1",
        url: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=500&auto=format&fit=crop&q=80",
        isLocked: false,
      },
      {
        id: "prev-2",
        url: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=500&auto=format&fit=crop&q=80",
        isLocked: true,
        lockTitle: "Subscribe to Unlock",
        lockSubtitle: "all exclusive content",
      },
      {
        id: "prev-3",
        url: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=500&auto=format&fit=crop&q=80",
        isLocked: false,
      },
    ],
    profileLink: "/tianamya",
  },

  // 5. Leslie Alexander Beach Video Post
  {
    itemType: "post",
    id: "post-4",
    creator: {
      id: "leslie-alexander",
      name: "Leslie Alexander",
      username: "leslie",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop&q=80",
      isVerified: true,
      category: "Lifestyle & Travel",
      isFollowing: true,
    },
    timeAgo: "2h ago",
    createdAt: "2h ago",
    caption: "Ready for new videos? Follow me for weekly drops.",
    hashtags: ["#fun", "#lifestyle"],
    tags: ["#fun", "#lifestyle"],
    category: "Lifestyle & Travel",
    media: [
      {
        type: "video",
        url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&auto=format&fit=crop&q=80",
        posterUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&auto=format&fit=crop&q=80",
        aspectRatio: "16/9",
      },
    ],
    likesCount: "987.2K",
    commentsCount: "47.2K",
    sharesCount: "4.53K",
    isLiked: false,
    isBookmarked: false,
  },

  // 6. Leslie Alexander Red Top Urban Video Post
  {
    itemType: "post",
    id: "post-5",
    creator: {
      id: "leslie-alexander",
      name: "Leslie Alexander",
      username: "leslie",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop&q=80",
      isVerified: true,
      category: "Lifestyle & Travel",
      isFollowing: true,
    },
    timeAgo: "2h ago",
    createdAt: "2h ago",
    caption: "Ready for new videos? Follow me for weekly drops.",
    hashtags: ["#fun", "#lifestyle"],
    tags: ["#fun", "#lifestyle"],
    category: "Lifestyle & Travel",
    media: [
      {
        type: "video",
        url: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1000&auto=format&fit=crop&q=80",
        posterUrl: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1000&auto=format&fit=crop&q=80",
        aspectRatio: "16/9",
      },
    ],
    likesCount: "987.2K",
    commentsCount: "47.2K",
    sharesCount: "11.72K",
    isLiked: false,
    isBookmarked: false,
  },
];

// Extracted helper lists
export const DUMMY_POSTS: FeedPost[] = DUMMY_TIMELINE_DATA.filter(
  (item): item is FeedPost => item.itemType === "post"
);

export const DUMMY_CREATORS: Creator[] = [
  {
    id: "c-1",
    name: "Jenny Wilson",
    username: "jenny",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
    isVerified: true,
    category: "Glamour & Fashion",
    isFollowing: true,
  },
  {
    id: "c-2",
    name: "Tiana Mya",
    username: "tianamya",
    avatar: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=150&auto=format&fit=crop&q=80",
    isVerified: true,
    category: "VIP Exclusive Model",
    isFollowing: false,
  },
  {
    id: "c-3",
    name: "Leslie Alexander",
    username: "leslie",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&auto=format&fit=crop&q=80",
    isVerified: true,
    category: "Lifestyle & Travel",
    isFollowing: false,
  },
  {
    id: "c-4",
    name: "Sophia Rose",
    username: "sophiarose",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&auto=format&fit=crop&q=80",
    isVerified: true,
    category: "Fitness & Wellness",
    isFollowing: false,
  },
];

export const DUMMY_STORIES: StoryItem[] = [
  {
    id: "s-1",
    creator: DUMMY_CREATORS[0],
    hasUnseenStory: true,
    isLive: true,
  },
  {
    id: "s-2",
    creator: DUMMY_CREATORS[1],
    hasUnseenStory: true,
  },
  {
    id: "s-3",
    creator: DUMMY_CREATORS[2],
    hasUnseenStory: false,
  },
  {
    id: "s-4",
    creator: DUMMY_CREATORS[3],
    hasUnseenStory: true,
  },
];

export const TRENDING_VAULT_ITEMS: VaultDropItem[] = [
  {
    id: "v-1",
    title: "Summer in Santorini 4K Set",
    creator: "Jenny Wilson",
    price: "40 Credits",
    coverImage: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=400&auto=format&fit=crop&q=80",
  },
  {
    id: "v-2",
    title: "Private Penthouse Glamour Session",
    creator: "Tiana Mya",
    price: "75 Credits",
    coverImage: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400&auto=format&fit=crop&q=80",
  },
];
